<template><div></div></template>

<script>
import { mapActions } from 'vuex';

export default {
  components: {},
  data() {
    return {
      show: false,
      audio: null,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions(['chAudioPlaying']),
    play() {
      if (!this.audio) return;
      if (this.audio.paused) {
        this.audio.addEventListener('ended', () => {
          this.audio.currentTime = 0;
          this.audio.play();
        }, false);
        this.audio.play();
        this.chAudioPlaying(true);
      } else {
        this.audio.pause();
        this.chAudioPlaying(false);
      }
    },
    pause() {
      if (!this.audio) return;
      this.audio.pause();
      this.chAudioPlaying(false);
    },
  },
  mounted() {
    this.audio = new Audio('https://storage.googleapis.com/deepdivedjkt/clg/sounds/main-69NVAGW-on-the-beach.mp3');
    this.audio.volume = 0.2;
  },
};
</script>
